import React, { Component } from 'react';
import TZDatePickerStart from '../TZDatePickerStart';
import { getSysFieldid } from '@platform/api';
require('./index.less');

class TZDatePickerStartBetween extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: props.value
		};
	}
	componentWillReceiveProps(nextProps) {
		// this.state.value = nextProps.value;
		this.setState({ value: nextProps.value });
	}
	render() {
		let { fieldid, dropdownClassName, ...others } = this.props;

		if (getSysFieldid(fieldid)) {
			dropdownClassName = dropdownClassName ? dropdownClassName + ` fieldid_${fieldid}_calendar` : `fieldid_${fieldid}_calendar`;
		}

		return (
			<div className="datepickerbetween TZDatePickerStartBetween" fieldid={getSysFieldid(fieldid)}>
				<div className="startDatePicker datepickerbetween-item">
					<TZDatePickerStart
						{...others}
						dropdownClassName={dropdownClassName}
						value={this.state.value && this.state.value[0]}
						onChange={this.props.onChange && this.props.onChange.bind(this, 0)}
					/>
				</div>
				<div className="line">-</div>
				<div className="endDatePicker datepickerbetween-item">
					<TZDatePickerStart
						{...others}
						dropdownClassName={dropdownClassName}
						value={this.state.value && this.state.value[1]}
						onChange={this.props.onChange && this.props.onChange.bind(this, 1)}
					/>
				</div>
			</div>
		);
	}
}

export default TZDatePickerStartBetween;
